module.exports = __webpack_public_path__ + "img/sandwich.6ccf2e11.png";